import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { IError } from "itsf-ui-common";
import { useStancer3dsIframe } from "./useStancer3dsIframe";
import { IHpp } from "../IStancerPayment";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";

interface IParams {
    hpp: IHpp;
    validatePaymentApiRoute: string;
    successCallback(): void;
    errorCallback?(error: IError): void;
}

export const Stancer3dsIframe = (props: IParams) => {
    const { hpp, validatePaymentApiRoute, successCallback, errorCallback } = props;
    const { t } = useTranslation("payment");
    const { classes } = useStyle();

    const {
        iframeKey,
        iframeFetchState: { isLoading, error },
    } = useStancer3dsIframe({
        paymentIntentId: hpp.paymentIntentId,
        validatePaymentApiRoute,
        successCallback,
        errorCallback,
    });

    return (
        <HandleErrorAndLoading error={error} isLoading={isLoading}>
            <iframe
                className={classes.iframe}
                id="target-iframe"
                key={iframeKey}
                src={hpp.url}
                title={t("3dsIframe")}
            />
        </HandleErrorAndLoading>
    );
};
